<template>
  <StepLayout
    :on-back="onBack"
    :on-save="onSave"
    :is-busy-on-save="isBusyOnSave"
    :on-next="onNext"
    :is-busy-on-next="isBusyOnNext"
    :is-disabled="isDisabled"
    help-link="https://signable.help/how-do-i-cancel-an-envelope-without-notifying-assigned-parties-2/"
    step-navigation-button-data-ec="bulk_send_expiry_page"
  >
    <template v-slot:title>
      {{ $t('bulkSend.steps.expiry.title') }}
    </template>
    <p class="text-black">{{ $t('bulkSend.steps.expiry.noExpirySetInfo') }}</p>
    <div class="flex items-center">
      <ElDatePicker
        v-model="expiry"
        type="date"
        data-ec="bulk_send_expiry_page"
        data-et="date_picker"
        :format="dateFormat"
        :picker-options="pickerOptions"
        :placeholder="$t('functional.pickADay')"
      />
      <BaseButton
        variant="invisible"
        @click.native="resetExpiry"
        data-ec="bulk_send_expiry_page"
        data-et="reset_expiry_button"
      >
        <span>{{ $t('functional.reset') }}</span>
      </BaseButton>
    </div>
  </StepLayout>
</template>


<script>
import { useGetters } from 'vuex-composition-helpers/dist';
import { computed, ref } from 'vue';

import dateFormat from '@/mixins/americanDateSwitcherMixin';
import { useBulkSendStepsNavigation } from '@/composables/bulkSend/steps';

import StepLayout from '@/components/ui/bulkSend/StepLayout.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'ExpiryPage',
  components: {
    StepLayout,
    BaseButton,
  },
  setup() {
    // get bulk send data
    const { bulkSend } = useGetters({ bulkSend: 'bulkSend/bulkSend' });

    const date = bulkSend.value.envelope_expires_after ? new Date(bulkSend.value.envelope_expires_after * 1000) : null;

    // initialise local state
    const expiry = ref(date);

    const isValid = computed(() => !expiry.value || expiry.value > Date.now());

    const updateValue = computed(() => ({
      envelope_expires_after: expiry.value ? Math.floor(expiry.value.getTime() / 1000) : null,
    }));

    // Tell bulk send steps the action and
    // the data to dispatch update when navigating to next page
    const {
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    } = useBulkSendStepsNavigation(
      'bulkSend/updateBulkSend',
      updateValue,
      isValid,
    );

    return {
      expiry,
      bulkSend,
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    };
  },
  mixins: [dateFormat],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [
          {
            text: this.$t('envelope.expiryIntervals.1day'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + (3600 * 1000 * 24));
              picker.$emit('pick', date);
            },
          },
          {
            text: this.$t('envelope.expiryIntervals.1week'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 7));
              picker.$emit('pick', date);
            },
          },
          {
            text: this.$t('envelope.expiryIntervals.30days'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 30));
              picker.$emit('pick', date);
            },
          },
        ],
      },
    };
  },
  methods: {
    resetExpiry() {
      this.expiry = null;
    },
  },
};
</script>
